import { IsNotEmpty, IsOptional, Matches } from 'class-validator';

export class HttpNodeVariable {
  @Matches(/^[a-zA-Z0-9._-]*$/i, { message: 'Please enter a variable that is alphanumeric with no spaces' })
  @IsNotEmpty()
  name: string;

  @IsOptional()
  expression?: string;
}
